import { useState, useRef, useEffect } from 'react';

// TODO: put in common component

/*
 * this hook determines if window.caiEventBus is ready and returns caiEventBus instance, event bus status
 */
const useEventBus = () => {
	const eventBusRef = useRef(null);
	const [isReady, setIsReady] = useState(false);

	useEffect(() => {
		let intervalId;
		let timeoutId;

		if (window.caiEventBus) {
			eventBusRef.current = window.caiEventBus;
			setIsReady(true);
		} else {
			timeoutId = setTimeout(() => {
				clearInterval(intervalId);
			}, 2000);

			const checkForEventBus = () => {
				if (window.caiEventBus) {
					eventBusRef.current = window.caiEventBus;
					setIsReady(true);
					clearInterval(intervalId);
					clearTimeout(timeoutId);
				}
			};
			intervalId = setInterval(checkForEventBus, 100);
		}
		return () => {
			if (intervalId || timeoutId) {
				clearInterval(intervalId);
				clearTimeout(timeoutId);
			}
		};
	}, []);

	return [eventBusRef.current, isReady];
};

export default useEventBus;
